// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3qbon","title":"Header_title__27wCO","left":"Header_left__2bMUv","clinicName":"Header_clinicName__1lQNM"};